import { Dictionary } from "../datastructures/Dictionary";

export interface FormDefinition<T> {
  [key: string]: FormFieldDefinition<T>;
}
export interface FormFieldDefinition<T> {
  label: string;
  required: boolean;
  type: FormFieldType;
  greaterThan?: number;
  precision?: number;
  /** Column width from the `sm` breakpoint up (1-12). Defaults to full width. */
  width?: string;
  /** Optional column width from the `lg` breakpoint up (1-12). */
  lgWidth?: string;
  /** Keeps the field out of the generated grid while it stays part of the form data. */
  hidden?: boolean;
  regex?: RegExp;
  error?: string;
  hint?: string;
  maxLength?: number;
  defaultValue?: any;
  multiline?: boolean;
  itemDefinition?: SelectionItemDefinition;
  validate?: (formData: T) => string | boolean;
}
export enum FormFieldType {
  Text,
  Number,
  Date,
  Selection,
  MultiSelect,
  Checkbox,
  Time,
  File,
  TimeSpan,
  Interval
}

export interface SelectionItemDefinition {
  items: () => Array<Dictionary<unknown>> | Promise<Array<Dictionary<unknown>>>;
  generator?: Generator;
  valueKey?: string;
  textKey?: string;
}
